import i18n from 'i18next'
import { useCallback, useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { Header } from '../components/Header'
import { TermsDialog } from '../components/TermsDialog'
import { useUser } from '../hooks/useUser'
import { useUserFunctions } from '../hooks/useUserFunctions'
import { tokenAtom, userIdAtom } from '../state/state'

export const ProtectedRoute = ({ redirectPath = '/login', children }) => {
  const token = useRecoilValue(tokenAtom)
  const userId = useRecoilValue(userIdAtom)
  const location = useLocation()
  const { data: userData, refetch: refetchUser } = useUser()
  const { acceptTerms } = useUserFunctions()

  useEffect(() => {
    const lng = (userData as any)?.preferredLanguage as 'hr' | 'en' | undefined
    if (lng && lng !== i18n.language) {
      i18n.changeLanguage(lng)
    }
  }, [(userData as any)?.preferredLanguage])

  const handleAcceptTerms = useCallback(async () => {
    await acceptTerms.mutateAsync({ identifier: userData?.email || userData?.username })
    await refetchUser()
  }, [acceptTerms, refetchUser, userData?.email, userData?.username])

  if (!token || !userId) {
    return <Navigate to={redirectPath} replace state={{ from: location }} />
  }

  const termsVisible = !userData?.acceptedTerms && !!userData?.id

  return children ? (
    <>
      <TermsDialog visible={termsVisible} onAccept={handleAcceptTerms} tenantId={userData?.tenant?.id} />
      <Header />
      {children}
    </>
  ) : (
    <>
      <TermsDialog visible={termsVisible} onAccept={handleAcceptTerms} tenantId={userData?.tenant?.id} />
      <div style={{ height: '80px' }}>
        <Header />
      </div>
      <Outlet />
    </>
  )
}
